package com.essntl.core.axus.di

import com.essntl.core.axus.data.AxusClientImpl
import com.essntl.core.axus.domain.AxusClient
import org.koin.dsl.module

val axusModule
    get() =
        module {
            single<AxusClient> { AxusClientImpl(get()) }
        }
